import { Polygon } from 'react-leaflet';
import { LatLngExpression } from 'leaflet';
import { useTheme } from 'styled-components';

import { FieldPolygonProps } from './FieldPolygon.type';

export const FieldPolygon = ({ coordinates }: FieldPolygonProps) => {
    const { colors } = useTheme();

    if (coordinates.length < 3) return null;

    const polygonPositions: LatLngExpression[] = coordinates.map((point) => [
        point.latitude,
        point.longitude,
    ]);

    return (
        <Polygon
            positions={polygonPositions}
            pathOptions={{
                color: colors.secondary600,
                weight: 3,
                opacity: 1,
                fillOpacity: 0.2,
            }}
        />
    );
};
